import React from "react";
import Select, { components } from "react-select";
import Cookies from "js-cookie";

// Language data with emoji flags and names
const languageOptions = [
  { value: "en", label: "EN - English", shortLabel: "EN" },
  { value: "fr", label: "FR - Français", shortLabel: "FR" },
  { value: "nl", label: "NL - Nederlands", shortLabel: "NL" }, 
  { value: "de", label: "DE - Deutsch", shortLabel: "DE" },
];

// Customize how selected value looks → show only flag
const SingleValue = ({ data, ...props }) => (
  <components.SingleValue {...props}>
    <p style={{ fontSize: "15px" }}>🌐 {data.shortLabel}</p>
  </components.SingleValue>
);

// Customize how dropdown options look → flag + name
const customGetOptionLabel = (e) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    {/* <span style={{ marginRight: 8 }}>{e.flag}</span> */}
    <span>{e.label}</span>
  </div>
);

// Optional: custom styles
const customStyles = {
  control: (provided) => ({
    ...provided,
    //width: 120, // 👈 Set your custom width
    //height: 30, // 👈 Set your custom height
    //minHeight: 30, // 👈 Important: override default min height
    backgroundColor: "transparent",
    // boxShadow: "none", // ✅ Remove shadow if needed
    // border: "none", // ✅ Optional: remove border
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    width: 150, // dropdown menu width
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "16px",
    padding: "10px",
  }),
  container: (provided) => ({
    ...provided,
    marginTop: "10px", // 👈 Move the select down by 40px
  }),
};

const LanguageDropdown = ({ onChange }) => {
const currentLang = localStorage.getItem("lang") || "en";
   
    let currentLanguageIndex = 0
    if (currentLang == 'en'){
      currentLanguageIndex = 0
    }
    else if (currentLang == 'fr') {
      currentLanguageIndex = 1
    }
    else if (currentLang == 'nl') {
      currentLanguageIndex = 2
    }
    else if (currentLang == 'de') {
      currentLanguageIndex = 3
    }
    else {
      currentLanguageIndex = 0
    }

  return (
    <Select
      options={languageOptions}
      defaultValue={languageOptions[currentLanguageIndex]}
      getOptionLabel={customGetOptionLabel}
      components={{
        SingleValue,
        // DropdownIndicator: () => null,
        // IndicatorSeparator: () => null,
      }}
      styles={customStyles}
      isSearchable={false}
      onChange={onChange}
    />
  );
};

export default LanguageDropdown;
